<app-main-layout>
  <app-calendar-page></app-calendar-page>
</app-main-layout>
